import axios from 'axios';

import { ContentTypeEnum } from '@/enums/httpEnum';
export default axios.create({
  headers: {
    'Content-type': ContentTypeEnum.JSON
  }
});
